import './platform-filter-modal.css'

import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'

import { useBoundStore } from '../../store/store'
import type { CasinoCategory } from '../../types/game'
import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import Icon from '../icon'
import Modal from './modal'

// const SortByButton = styled.button`
//   margin-right: 20px;
//   color: #fff;
// `

type PlatformFilterModalProps = {
  category?: CasinoCategory | null
  selectedPlatform: string
  setSelectedPlatform: (platform: string) => void
}

// const Dropdown = styled.div`
//   position: relative;
// `

// const Options = styled.div`
//   position: absolute;
//   top: 100%;
//   right: 0;
//   background: var(--highlight);
//   border-radius: 6px;
//   padding: 8px;
//   opacity: 0;
//   transition: all 0.2s ease-in-out;
//   pointer-events: none;
//   &.active {
//     opacity: 1;
//     pointer-events: auto;
//   }
// `

// const Option = styled.div`
//   font-family: 'Poppins';
//   font-style: normal;
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 21px;
//   color: var(--secondary-btn-txt);
//   padding: 5px 15px;
//   background-color: var(--highlight);
//   border-radius: 5px;
//   cursor: pointer;
//   &.selected {
//     background-color: var(--primary);
//     color: var(--highlight);
//   }
// `

const PlatformFilterModal = ({
  category,
  selectedPlatform,
  setSelectedPlatform,
}: PlatformFilterModalProps) => {
  const modal = useModal()
  const providers = useBoundStore(state => state.casino.providers)
  const theme = useBoundStore(state => state.common.theme)
  const { t } = useTranslation('casino')
  // const [sortBy, setSortBy] = useState(sortByOptions[0].value)
  // const [isOpen, setIsOpen] = useState(false)

  // const sortByOptions = [
  //   { id: 1, label: t('popular', { ns: 'casino' }), value: 'popular' },
  //   { id: 2, label: t('alphabetical', { ns: 'casino' }), value: 'alphabetical' },
  // ]

  return (
    <Modal
      id="platform-filter-modal"
      containerStyle={classNames(
        'platform-filter-modal animate-slideUp xl:animate-fadeIn top-[calc(50vh-47px)] xl:top-1/2 left-[unset] xl:left-1/2',
        'bottom-0 xl:bottom-[unset] transform-none xl:-translate-x-1/2 xl:translate-y-[calc(-50%-50px)]',
        'w-full max-w-[500px] border-none rounded-none xl:rounded-xl pl-0 pr-0 !pt-0 !pb-[0px] xl:overflow-hidden',
      )}>
      {/* Modal Header */}
      <div className="flex p-3 bg-highlight items-center">
        {/* Modal Title */}
        <div className="flex mr-auto text-sm font-normal text-white">
          {/* Icon Wrapper */}
          <div className="flex items-center mr-2">
            <Icon id="platform-filter" width={18} height={18} fill="#fff" />
          </div>
          {t('game-provider', { ns: 'casino' })}
          {/* Badge */}
          <div className="min-w-[23px] ml-[6px] pt-[1px] px-[5px] border border-white rounded-[52px] text-sm text-white text-center font-normal leading-5">
            {Object.keys(category?.providers ?? {}).length}
          </div>
        </div>
        {/* <Dropdown>
          <SortByButton
            onClick={() => {
              setIsOpen(prev => !prev)
            }}>
            <Icon id="sort" width={23} height={23} fill="#fff" />
          </SortByButton>
          <Options className={isOpen ? 'active' : ''}>
            {sortByOptions.map(prop => (
              <Option
                key={prop.id}
                className={sortBy === prop.value ? 'selected' : ''}
                onClick={() => {
                  setSortBy(prop.value)
                  setIsOpen(false)
                }}>
                {prop.label}
              </Option>
            ))}
          </Options>
        </Dropdown> */}
        <button
          onClick={() => {
            closeModal(modal)
          }}>
          <Icon id="close" height={16} width={16} fill="#ffffff" />
        </button>
      </div>
      {/* Modal Body */}
      <div className="modal-body p-3 xl:p-4 max-h-[50vh] xl:max-h-[450px] overflow-y-auto">
        {/* Content */}
        <div className="grid gap-y-4 gap-x-3 grid-cols-[1fr_1fr]">
          {Object.keys(category?.providers ?? {})
            .sort()
            .map(
              key =>
                providers?.[key] && (
                  <div
                    className={classNames(
                      'flex items-center justify-center h-[44px] xl:h-[58px] bg-secondary border rounded-[5px] cursor-pointer p-1',
                      selectedPlatform === key
                        ? 'border-highlight'
                        : 'border-transparent',
                    )}
                    key={key}
                    onClick={() => {
                      setSelectedPlatform(key)
                      closeModal(modal)
                    }}>
                    <img
                      src={
                        providers?.[key][
                          theme === 'dark' ? 'iconDark' : 'iconLight'
                        ]
                      }
                      alt={key}
                      className="h-full"
                    />
                  </div>
                ),
            )}
        </div>
      </div>
    </Modal>
  )
}

export default NiceModal.create(PlatformFilterModal)
